import { createSlice } from "@reduxjs/toolkit";
 const subscriptionSlice = createSlice({
    name:"subscription",
    initialState:{
        plan : "Free",
        discount:0
    },
    reducers:{
        setSubscriptionPlan :(state , action)=>{
            state.plan = action.payload

            if(action.payload === "Pro") state.discount =20
            else if(action.payload == "Enterprise") state.discount =30
            else state.discount = 0
        }
    }
 })

 export const {setSubscriptionPlan } = subscriptionSlice.actions;
 export default subscriptionSlice.reducer;